
export default (formidableFetchedData: any, fetchedData: any) => (candidacy: any) => {
  formidableFetchedData.setForm({
    ...fetchedData,
    shortlist: [...fetchedData.shortlist, candidacy],
  });
}